import React, { useState, useEffect } from 'react';
import { useLoading } from '../LoadingContext';  // ★ 追加
import '../../styles/CurriculumVideoSection.css';

const API_BASE = 'https://5uqm251uv5.execute-api.ap-northeast-3.amazonaws.com/prod/api/admin/videos';

const CurriculumVideoSection = () => {
  const { startLoading, finishLoading } = useLoading();  // ★ 追加
  const [videos, setVideos] = useState([]);
  const [curriculumList, setCurriculumList] = useState([]);
  const [sessionList, setSessionList] = useState([]);

  const [selectedCurriculum, setSelectedCurriculum] = useState('');
  const [selectedSession, setSelectedSession] = useState('');
  const [youtubeUrl, setYoutubeUrl] = useState('');

  // 初回ロード：動画一覧とカリキュラム一覧を同時に取得
  useEffect(() => {
    const init = async () => {
      startLoading();
      try {
        await Promise.all([loadVideos(), loadCurriculums()]);
      } finally {
        finishLoading();
      }
    };
    init();
  }, []);

  // 動画一覧取得
  const loadVideos = async () => {
    startLoading();
    try {
      const res = await fetch(API_BASE, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`,
        },
        body: JSON.stringify({ action: 'list' }),
      });
      const data = await res.json();
      setVideos(data.videos || []);
    } catch (err) {
      console.error('❌ loadVideos error', err);
    } finally {
      finishLoading();
    }
  };

  // カリキュラム一覧取得
  const loadCurriculums = async () => {
    startLoading();
    try {
      const res = await fetch(API_BASE, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`,
        },
        body: JSON.stringify({ action: 'list-curriculums' }),
      });
      const data = await res.json();
      setCurriculumList(data.curriculums || []);
    } catch (err) {
      console.error('❌ loadCurriculums error', err);
    } finally {
      finishLoading();
    }
  };

  // 対象回リスト取得
  const handleCurriculumChange = async (e) => {
    const curriculum = e.target.value;
    setSelectedCurriculum(curriculum);
    setSelectedSession('');
    if (!curriculum) {
      setSessionList([]);
      return;
    }
    startLoading();
    try {
      const res = await fetch(API_BASE, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`,
        },
        body: JSON.stringify({ action: 'list-sessions', curriculumName: curriculum }),
      });
      const data = await res.json();
      setSessionList(data.sessions || []);
    } catch (err) {
      console.error('❌ list-sessions error', err);
    } finally {
      finishLoading();
    }
  };

  // 新規登録
  const handleRegister = async () => {
    if (!selectedCurriculum || !selectedSession || !youtubeUrl) {
      alert('すべての項目を選択・入力してください');
      return;
    }
    startLoading();
    try {
      await fetch(API_BASE, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`,
        },
        body: JSON.stringify({
          action: 'register',
          curriculumName: selectedCurriculum,
          sessionNumber: Number(selectedSession.replace('第', '').replace('回', '')),
          youtubeUrl,
        }),
      });
      setSelectedCurriculum('');
      setSelectedSession('');
      setYoutubeUrl('');
      setSessionList([]);
      await loadVideos();
    } catch (err) {
      console.error('❌ register error', err);
      alert('登録中にエラーが発生しました');
    } finally {
      finishLoading();
    }
  };

  // 削除
  const handleDelete = async (videoId) => {
    if (!window.confirm('この動画を削除しますか？')) return;
    startLoading();
    try {
      await fetch(API_BASE, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`,
        },
        body: JSON.stringify({ action: 'delete', videoId }),
      });
      await loadVideos();
    } catch (err) {
      console.error('❌ delete error', err);
      alert('削除中にエラーが発生しました');
    } finally {
      finishLoading();
    }
  };

  return (
    <div className="curriculum-video-section">
      <h3 className="section-title">新規カリキュラム動画登録</h3>
      <div className="form-group">
        <select
          className="select-input"
          value={selectedCurriculum}
          onChange={handleCurriculumChange}
        >
          <option value="">カリキュラム名を選択</option>
          {curriculumList.map((curriculum) => (
            <option key={curriculum} value={curriculum}>
              {curriculum}
            </option>
          ))}
        </select>
        <select
          className="select-input"
          value={selectedSession}
          onChange={(e) => setSelectedSession(e.target.value)}
        >
          <option value="">対象回を選択</option>
          {sessionList.map((session) => (
            <option key={session} value={session}>
              {session}
            </option>
          ))}
        </select>
        <input
          className="text-input"
          placeholder="YouTube URL"
          value={youtubeUrl}
          onChange={(e) => setYoutubeUrl(e.target.value)}
        />
        <button className="primary-button" onClick={handleRegister}>
          登録
        </button>
      </div>

      <h3 className="section-title">登録済みカリキュラム動画一覧</h3>
      <table className="video-table">
        <thead>
          <tr>
            <th>カリキュラム名</th>
            <th>対象回</th>
            <th>YouTube URL</th>
            <th>削除</th>
          </tr>
        </thead>
        <tbody>
          {videos.map((video) => (
            <tr key={video.id}>
              <td>{video.curriculum_name}</td>
              <td>第{video.session_number}回</td>
              <td>{video.youtube_url}</td>
              <td>
                <button
                  className="danger-button"
                  onClick={() => handleDelete(video.id)}
                >
                  削除
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CurriculumVideoSection;
